// extracted by mini-css-extract-plugin
export default {"faqsSection":"faqsSection__NTQ0M","itemCount":"itemCount__NGRiN"};